import { Box, styled } from '@mui/material'
import { blueGrey } from '@mui/material/colors'

export const DraggableContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: blueGrey[100],
  padding: '3px',
  fontSize: theme.typography.body2.fontSize,
  color: blueGrey[500],
  cursor: 'grab',
  '&:hover': {
    backgroundColor: blueGrey[200],
  },
  '&:active': {
    cursor: 'grabbing',
  },
}))
